import React, { useState } from "react";
import GalleryFormComponent from "./galleryForm.component";
import PropTypes from "prop-types";
import {
  toBase64,
  createGalleryContentModel
} from "../../../utils/productPage.util";
import { connect, useSelector } from "react-redux";
import { addAlert } from "modules/notification";
import GalleryDetailForm from "../galleryDetailForm";
import { getLang } from "app/feature/constants";

const TYPES = ["new", "edit", "readonly"];
const INPUT_METHODS = ["browse_file", "image_url"];
const MAX_IMAGE_COUNT = 10;
const MAX_IMAGE_SIZE = 1024 * 1024 * 12;

function getInitialOrder(order) {
  const length = order.length;

  if (!length || length < MAX_IMAGE_COUNT) return [...order];
  else return order;
}

function GalleryFormContainer({
  type,
  handleResult,
  handleDelete,
  initialValues,
  showAlert,
  lang,
  handleClose
}) {

  const [order, setOrder] = useState(() => {
    let initialOrder =
      type === TYPES[0]
        ? lang.map(code => ({ lang: code, value: initialValues.order }))
        : getInitialOrder(initialValues.order);
  
    // if (!(Array.isArray(initialOrder) && initialOrder.length > 0 && initialOrder[0].value)) {
    //   initialOrder = lang.map(code => ({
    //     lang: code,
    //     value: code === "EN" ? initialOrder : []
    //   }));
    // }

    if (Array.isArray(initialOrder) && initialOrder.every(item => item.lang && "value" in item)) {
      initialOrder = lang.map(code => {
          const matchingEntry = initialOrder.find(entry => entry.lang === code);
          return {
              lang: code,
              value: matchingEntry ? matchingEntry.value : []
          };
      });
    } else {
      initialOrder = lang.map(code => ({
          lang: code,
          value: code === "EN" ? initialOrder : []
      }));
    }
  

    return initialOrder;
  });

  // const [images, setImages] = useState(
  //   type === TYPES[0]
  //     ? lang.map(code => ({ lang: code, value: initialValues.images }))
  //     : initialValues.images
  //   );

  const [images, setImages] = useState(() => {
    let initialImages =
      type === TYPES[0]
        ? lang.map(code => ({ lang: code, value: initialValues.images }))
        : initialValues.images

    // if (!(Array.isArray(initialImages) && initialImages.length > 0 && initialImages[0].value)) {
    //   initialImages = lang.map(code => ({
    //     lang: code,
    //     value: code === "EN" ? initialImages : {}
    //   }));
    // }

    if (Array.isArray(initialImages) && initialImages.every(item => item.lang && "value" in item)) {
      initialImages = lang.map(code => {
        const matchingEntry = initialImages.find(entry => entry.lang === code);
        return {
          lang: code,
          value: matchingEntry ? matchingEntry.value : []
        };
      });
    } else {
      initialImages = lang.map(code => ({
        lang: code,
        value: code === "EN" ? initialImages : {}
      }));
    }
    return initialImages;
  });

  const [activeIndexTab, setActiveIndexTab] = useState(0);
  const [activeOrder, setActiveOrder] = useState(order[activeIndexTab].value);
  const [activeImages, setActiveImages] = useState(images[activeIndexTab].value);

  const [isLoading, setLoading] = useState(false);
  const [imageName, setImageName] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [imageLink, setImageLink] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [isEditingLink, setIsEditingLink] = useState(false);
  const [isEnableFullscreenBtn, setIsEnableFullscreenBtn] = useState(initialValues.isEnableFullscreenBtn ?? false);
  const languages = useSelector(state => state.constant.languages)

  const handleChangeTab = index => {
    setActiveIndex(index);
  };

  const handleChangeEnableFullscreenBtn = () => {
    setIsEnableFullscreenBtn(prev => prev !== true);
  }

  const handleFileUpload = async files => {
    if (!files[0]) {
      return;
    }

    if (files[0].size > MAX_IMAGE_SIZE) {
      showAlert({
        severity: "error",
        message: getLang(languages,"message.error.IMAGE_EXCEED_MAXIMUM_FILE_SIZE_12")
      });
      return;
    }

    if (activeOrder.length >= MAX_IMAGE_COUNT) {
      showAlert({
        severity: "error",
        message: getLang(languages,"message.error.MAXIMUM_IMAGE_ALLOWED")
      });
      return;
    }

    setLoading(true);

    const filename = files[0].name.replace(/\s/g, "");
    const base64Image = await toBase64(files[0]);
    const image = {
      id: filename,
      img: base64Image,
      type: files[0].type,
      destinationURL: ""
    };

    setLoading(false);

    if (activeOrder.includes(filename)) {
      showAlert({
        severity: "error",
        message: getLang(languages,"message.error.IMAGE_EXISTS")
      });
      return;
    }
    let newImage = { ...activeImages };
    const newOrder = Array.from(activeOrder);

    newImage = {
      ...newImage,
      [filename]: {
        ...image,
        source: INPUT_METHODS[0],
        destinationURL: imageLink
      }
    };
    newOrder.push(filename);

    const newOrders = order.map((item, index) =>
      index === activeIndexTab ? { ...item, value: newOrder } : item
    );
    
    const newImages = images.map((item, index) =>
      index === activeIndexTab ? { ...item, value: newImage } : item
    );
    
    setActiveImages(newImage);
    setActiveOrder(newOrder);
    setOrder(newOrders);
    setImages(newImages);
    
    handleResetInput();
    setImageLink("");
  };

  const handleDeleteImage = id => {
    const newOrder = { ...order[activeIndexTab], value: activeOrder.filter(c => c !== id)};
    const newImage = { ...images[activeIndexTab], value: activeImages };
    const { [id]: removed, ...newValue } = newImage.value;
    const updatedNewImage = {
      ...newImage,
      value: newValue,
    };

    const newOrders = Array.from(order);
    const newImages = Array.from(images);
    newOrders.splice(activeIndexTab, 1, newOrder);
    newImages.splice(activeIndexTab, 1, updatedNewImage);

    setOrder(newOrders);
    setImages(newImages);
    setActiveOrder(newOrder.value);
    setActiveImages(updatedNewImage.value);
  };

  const handleSubmit = () => {

    if (
      Array.isArray(order.find(e => e.lang === "EN")?.value) &&
      order.find(e => e.lang === "EN")?.value.length === 0
    ) {
      showAlert({
        severity: "error",
        message: getLang(languages,"message.error.IMAGE_GALLERY_NO_EN_IMAGE")
      });
      return;
    }

    handleResult({
      images,
      order,
      isEnableFullscreenBtn
    });
  };

  const handleResetInput = () => {
    setImageName("");
    setImageUrl("");
  };

  const handleChangeLink = ({ name, value }) => {
    setIsEditingLink(false)

    const oldImage = activeImages[name];
    let newImage = { ...images[activeIndexTab], value: activeImages };
    const { [name]: removed, ...filteredValue } = newImage.value;
    
    newImage = {
      ...newImage,
      value: {
        ...filteredValue,
        [imageName]: {
          ...oldImage,
          destinationURL: value
        }
      }
    };

    setActiveImages(newImage.value);
    const newImages = Array.from(images);
    newImages.splice(activeIndexTab, 1, newImage);
    setImages(newImages);
  };

  const handleRejected = errorMessage => {
    showAlert({
      severity: "error",
      message: errorMessage
    })
  }

  const handleInsertLink = id => {
    const selectedImage = activeImages[id];

    setImageName(selectedImage.id);
    setImageUrl(selectedImage.img);
    setImageLink(selectedImage.destinationURL);
    setIsEditingLink(true);
  }

  const handleBack = () => {
    setIsEditingLink(false);
  }

  const handleChangeActiveIndexTab = (e, index) => {
    const newOrder = { ...order[activeIndexTab], value: activeOrder };
    const newImage = { ...images[activeIndexTab], value: activeImages };
    const newOrders = Array.from(order);
    const newImages = Array.from(images);
    newOrders.splice(activeIndexTab, 1, newOrder);
    newImages.splice(activeIndexTab, 1, newImage);
    setOrder(newOrders);
    setImages(newImages);
    setActiveOrder(newOrders[index].value);
    setActiveImages(newImages[index].value);
    setActiveIndexTab(index);
  };

  return (
    <>
      {!isEditingLink ?
        <GalleryFormComponent
          type={type}
          handleSubmit={handleSubmit}
          order={type === TYPES[2] ? initialValues.order : order}
          images={type === TYPES[2] ? initialValues.images : images}
          handleDeleteImage={handleDeleteImage}
          handleDelete={handleDelete}
          activeIndex={activeIndex}
          handleChangeTab={handleChangeTab}
          MAX_IMAGE_COUNT={MAX_IMAGE_COUNT}
          handleRejected={handleRejected}
          isLoading={isLoading}
          handleFileUpload={handleFileUpload}
          handleInsertLink={handleInsertLink}
          handleClose={handleClose}
          isEnableFullscreenBtn={isEnableFullscreenBtn}
          handleChangeEnableFullscreenBtn={handleChangeEnableFullscreenBtn}
          lang={lang}
          languages={languages}
          activeIndexTab={activeIndexTab}
          handleChangeActiveIndexTab={handleChangeActiveIndexTab}
          activeOrder={activeOrder}
          activeImages={activeImages}
        />
        :
        <GalleryDetailForm
          imageName={imageName}
          imageUrl={imageUrl}
          imageLink={imageLink}
          handleChangeLink={handleChangeLink}
          handleBack={handleBack}
        />
      }
    </>
  );
}

GalleryFormContainer.defaultProps = {
  type: TYPES[0],
  initialValues: createGalleryContentModel()
};

GalleryFormContainer.propTypes = {
  type: PropTypes.oneOf(TYPES).isRequired,
  handleResult: PropTypes.func,
  handleDelete: PropTypes.func,
  initialValues: PropTypes.object
};

const mapDispatchToProps = dispatch => ({
  showAlert: payload => dispatch(addAlert(payload))
});

const mapStateToProps = state => ({
  lang: state.productPage.lang
});

export { TYPES };

export default connect(mapStateToProps, mapDispatchToProps)(GalleryFormContainer);
